import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import SubitemsTable from "./SubitemsTable";
import { SubitemsService } from "../services/SubitemsService";
import { ProjectService } from "../services/projectService";
import "./SubitemsModal.css";
import { useTrackModal } from "../hooks/useTrackModal";

const SubitemsModal = ({ project, isOpen, onClose }) => {
  useTrackModal("SubitemsModal", isOpen);
  const [subitems, setSubitems] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isOpen && project?.id) {
      loadData();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, project]);

  const loadData = async () => {
    setLoading(true);
    setError(null);
    
    try {
      // Load subitems and employees in parallel
      const [subitemsData, employeesData] = await Promise.all([
        SubitemsService.getSubitemsByProject(project.id),
        ProjectService.getEmployees()
      ]);
      
      setSubitems(subitemsData || []);
      setEmployees(employeesData || []);
    } catch (err) {
      console.error("Error loading subitems data:", err);
      setError("Failed to load subitems");
    } finally {
      setLoading(false);
    }
  };

  const handleSubitemUpdate = async (subitemId, field, value) => {
    try {
      await SubitemsService.updateSubitem(subitemId, field, value);
      // Reload subitems to get updated data
      await loadData();
    } catch (error) {
      console.error("Error updating subitem:", error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="subitems-modal-overlay" onClick={onClose}>
      <div className="subitems-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="subitems-modal-header">
          <h2>
            Subitems - {project?.projectName || project?.name || "Project"}
          </h2>
          <button className="subitems-modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="subitems-modal-body">
          <SubitemsTable
            subitems={subitems}
            loading={loading}
            error={error}
            onSubitemUpdate={handleSubitemUpdate}
            employees={employees}
            modelingStatus={project?.modelingStatus}
            projectId={project?.id}
          />
        </div>
      </div>
    </div>
  );
};

export default SubitemsModal;